import React from "react";

const Footer = () => {
  return (
        
    <div className="fixed bottom-0 z-50 w-full p-2 bg-black">
    <footer className="bg-[#1a1918] text-white text-center py-3 rounded-md mx-auto max-w-5xl mt-2 mb-2">
      <p className="text-xs">
        © Copyright 2025, Mandai Wildlife Group. All Rights Reserved.
      </p>
    </footer>
    </div>
  );
};

export default Footer;
